import { render } from "./DiesAcademicusPage.vue?vue&type=template&id=b6be48ee"
import script from "./DiesAcademicusPage.vue?vue&type=script&lang=js"
export * from "./DiesAcademicusPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__